<template>
  <div>
    <Search />
    <div style="height: 112px; width: 100%" />
    <div class="p-content firm-container">
      <div class="firm-title">浪潮智能终端公司介绍</div>
      <div class="firm-item">
        浪潮智能终端有限公司专注于智能终端领域，坚持以优质的服务品质为导向，专业的技术服务能力为支撑，聚焦发展超高清交互显示终端、智慧服务终端、智能感知终端、智慧家庭终端、智能医疗终端、虚拟现实终端六大专业智能终端领域，联合打造“云、网、边、端”一体化平台，提供基于应用场景的智能终端解决方案，助力智能交通、智慧能源、智能制造、智慧农业及水利、智慧教育、智慧医疗、智慧文旅、智慧社区、智慧家居和智慧政务等十大数字经济应用领域。
      </div>
      <div class="firm-item">
        浪潮智能终端致力于成为全国领先的智能终端制造商和专用产品方案供应商，面向金融、医疗、税务、广电、融媒体、文旅、家居、机器人、数字政府、数字乡村、水利、交通、能源、教育等多细分领域提供专用智能终端的研发、生产、销售、运维等服务。
      </div>
      <div class="firm-item">
        公司研发的8K超高清平台、超高清交互显示终端应用于中央春晚及科技冬奥项目，赋能“百城千屏”，被国家广电总局评选为超高清视频典型应用案例。研发的视频服务及监管平台、智能终端等产品，先后服务中宣部、中央电视台、中央新影集团、四大银行等重点客户，业务遍及全国各地及东南亚、西亚、欧洲、南美等海外客户，覆盖全球20多个国家和地区。
      </div>
    </div>
  </div>
</template>

<script>
import Search from '@/components/Search'
export default {
  name: 'FirmIntro',
  components: {
    Search
  },
  beforeRouteEnter(to, from, next) {
    window.scrollTo(0, 0)
    next()
  }
}
</script>

<style scoped>
.firm-container {
  border-bottom: 1px solid #ebebeb;
  padding-bottom: 50px;
}
.firm-title {
  font-size: 18px;
  color: black;
  font-weight: bold;
  text-align: center;
  margin-top: 30px;
  margin-bottom: 10px;
}
.firm-item {
  font-size: 14px;
  color: #3f3f3f;
  margin-top: 10px;
  text-indent: 2em;
  line-height: 25px;
}
</style>
